// Based on TiMessengerTestTreiber.yaml 2.0.0
import { inject, Injectable } from '@angular/core';
import { MatrixService } from '../matrix/matrix.service';
import { HomeserverSearchResultList } from '../../../shared-api/homeserverSearchResultList';
import { SearchOnHomeserverService as ApiSearchOnHomeserverService } from '../../../shared-api/searchOnHomeserver.service';
import { MatrixError } from 'matrix-js-sdk';
import { matrixErrorAsJson } from '../../errors/error-with-status';
import { SnackbarService } from '../snackbar/snackbar.service';

@Injectable({
  providedIn: 'root'
})
/**
 * Der SearchOnHomeserverService stellt eine Suchmöglichkeit auf dem Homeserver bereit.
 * Implementation of the mandatory SearchOnHomeserver API of the gematik TI-M Testtreiber
 * Umgesetze AFOs:
 * A_25363 - Testtreiber-Modul
 * A_25361 - keine Modifikation der Inhalte
 */
export class SearchOnHomeserverService implements ApiSearchOnHomeserverService {
  private readonly matrix = inject(MatrixService);
  private readonly snackbarService = inject(SnackbarService);

  /**
   * Returns a list of users on same homeserver that matches search parameters
   * @param displayName Display name of account
   * @param mxId MxId of account
   */
  public async searchOnHomeserver(displayName?: string, mxId?: string): Promise<HomeserverSearchResultList> {
    try {
      const result = await this.matrix.client.searchUserDirectory({
        term: displayName || mxId || '',
        limit: 50
      });
      if (result.limited) {
        this.snackbarService.info(
          'Ihre Suche ist zu ungenau, es werden möglicherweise nicht alle Ergebnisse angezeigt'
        );
      }
      return {
        totalSearchResults: result.results.length,
        searchResults: result.results.map(({ display_name, user_id }) => ({
          displayName: display_name,
          mxId: user_id
        }))
      } as HomeserverSearchResultList;
    } catch (error) {
      console.error('searchOnHomeserver fehlgeschlagen', error);

      if (!(error instanceof MatrixError)) {
        throw error;
      }
      throw matrixErrorAsJson('SearchOnHomeserverError', error);
    }
  }
}
